import { z } from 'zod';

// Schema para validación de registro
export const registerSchema = z.object({
  name: z.string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(50, 'El nombre no puede exceder 50 caracteres')
    .regex(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/, 'El nombre solo puede contener letras y espacios')
    .trim(),

  email: z.string()
    .email('Ingresa un email válido')
    .min(1, 'El email es requerido')
    .toLowerCase()
    .trim(),

  password: z.string()
    .min(8, 'La contraseña debe tener al menos 8 caracteres')
    .max(100, 'La contraseña no puede exceder 100 caracteres')
    .regex(/[A-Z]/, 'La contraseña debe contener al menos una letra mayúscula')
    .regex(/[a-z]/, 'La contraseña debe contener al menos una letra minúscula')
    .regex(/[0-9]/, 'La contraseña debe contener al menos un número'),

  confirmPassword: z.string()
    .min(1, 'Debes confirmar tu contraseña')
}).refine((data) => data.password === data.confirmPassword, {
  message: 'Las contraseñas no coinciden',
  path: ['confirmPassword'],
});

// Schema para validación de login
export const loginSchema = z.object({
  email: z.string()
    .email('Ingresa un email válido')
    .min(1, 'El email es requerido')
    .toLowerCase()
    .trim(),

  password: z.string()
    .min(1, 'La contraseña es requerida')
});

// Schema para validación de email (recuperar contraseña)
export const forgotPasswordSchema = z.object({
  email: z.string()
    .email('Ingresa un email válido')
    .min(1, 'El email es requerido')
    .toLowerCase()
    .trim()
});

// Función helper para validar y obtener errores
export const validateWithZod = (schema, data) => {
  try {
    schema.parse(data);
    return { success: true, data: data, errors: {} };
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errors = {};
      error.errors.forEach((err) => {
        const path = err.path[0];
        if (!errors[path]) {
          errors[path] = err.message;
        }
      });
      return { success: false, data: null, errors };
    }
    return { success: false, data: null, errors: { general: 'Error de validación' } };
  }
};
